import React from "react";
import { get } from 'lodash';
import { TextField, Box } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
const CustomMobilePhone = ({
 name,
 id,
 sx = {
   width: "100%",
   pb: 2,
 },
 children,
 label = "",
 inputProps,
 hidden,
 onChange,
 disabled,
 InputProps,
 size = "medium",
 labelProps = {},
 ...params
}) => {
  const { control,  formState } = useFormContext();
  const { errors } = formState;
  let parsedError = get(errors, name);

  return (
    <Box sx={{ height: "74px" }}>
      <Controller
        name={name}
        control={control}
        {...params}
        render={({ field }) => {
          return (
            <TextField
              {...field}
              size={size}
              hidden={hidden}
              error={Boolean(
                !!parsedError || params.error || false
              )}
              helperText={
                parsedError
                  ? parsedError.message
                  : params.helperText || ""
              }
              label={label}
              inputRef={field.ref}
              disabled={disabled}
              InputProps={InputProps}
              sx={sx}
              inputProps={{
                ...inputProps,
              }}
              onChange={onChange || field.onChange}
              onBlur={field.onBlur}
              InputLabelProps={labelProps}
            >
              {children}
            </TextField>
          );
        }}
      />
    </Box>
  );
};

export default CustomMobilePhone;
